module.exports = __webpack_public_path__ + "static/media/gifs_landingpage.001.c9cbbfe8.jpeg";